export function filterMaterialsCatalog(materials, query, { limit = 25 } = {}) {
  const search = query.trim().toLowerCase();

  if (!search) {
    return [];
  }

  return (materials || [])
    .filter((material) => {
      const name = material.material_name?.toLowerCase() || "";
      const sku = material.sku?.toLowerCase() || "";
      const description = material.description?.toLowerCase() || "";
      const materialType = material.material_type?.toLowerCase() || "";
      const manufacturer = material.manufacturer?.toLowerCase() || "";

      return (
        name.includes(search) ||
        sku.includes(search) ||
        description.includes(search) ||
        materialType.includes(search) ||
        manufacturer.includes(search)
      );
    })
    .slice(0, limit);
}
